import secureLocalStorage from "react-secure-storage";

let current_uri = secureLocalStorage.getItem("BaseURI");

export const BASEURI = current_uri
  ? current_uri
  : process.env.REACT_APP_BASE_URI;
